/** @format */

// MUI Box's `sx` prop produces a TypeScript union that grows past TS's
// union-complexity limit (TS2590) once @types/three is in scope alongside
// @mui/material. This module re-exports `Box` with a loosened type so call
// sites with `sx={{ ... }}` keep working without each file having to apply
// its own workaround.
//
// Runtime behavior is unchanged — only the static type evaluation is
// skipped. Theme tokens, breakpoint objects, callback values, etc. all
// continue to work as documented by MUI.

import { Box as MuiBox } from "@mui/material";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Box: any = MuiBox;
